/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const RailRightCloseIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Rail Right Close',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M22 14h-9.006a.994.994 0 0 0-.994.994v6.012a.994.994 0 0 0 .994.994H22v8.912a.5.5 0 0 0 .848.351L36 18 22.848 4.736a.5.5 0 0 0-.848.352Z"
    />
    <rect height="28" rx=".707" ry=".707" width="4" x="4" y="4" />
  </svg>`;
};
